import AnnotationSelectorEnum from '@components/data/annotation-selector/annotation-selector-enum.ts';

export enum LocalStorageKey {
	NavSidebarManuOptionSelected = `tgs-sb-m`,
	NavSidebarManuOptionOpen = `tgs-nbm-o`,
	TableSize = 'table-size',
	USDExchangeRates = 'gang-usd-rates',
	ColorTheme = 'theme',
	ExperienceTagTabSelected = 'tgs-et-dt',
	CCUToggleState = 'tgs-c-c-u-t-s',
	CookiePreferences = 'tgs-co-p',
	SignUpCallout = 'tgs-s-u-co',
	ChartAnnotationState = 'tgs-a-s',
	ChartAnnotationPickerState = 'tgs-a-p-s',
	TagDetailsExperienceListState = 'tgs-t-d-e-l-s',
}

export type LocalStorageKeyType =
	| `${string}-${LocalStorageKey.TableSize}`
	| `${LocalStorageKey.NavSidebarManuOptionOpen}-${string}`
	| `${LocalStorageKey.CCUToggleState}-${string}`
	| `${LocalStorageKey.ChartAnnotationState}-${AnnotationSelectorEnum}`
	| `${LocalStorageKey}`;

export interface CookiePreferences {
	st: boolean; // Session tracking
}
